import { ReusablePaymentMethodType } from './reusable-payment-method/reusable-payment-method-type';
import { WalletPaymentMethodType } from './wallet-payment-method/wallet-payment-method-type';

export type PaymentMethodType = WalletPaymentMethodType | ReusablePaymentMethodType;

export const isReusablePaymentMethodType = (paymentMethodType: PaymentMethodType): paymentMethodType is ReusablePaymentMethodType =>
  paymentMethodType !== 'APPLE_PAY' && paymentMethodType !== 'GOOGLE_PAY';
